import { render, staticRenderFns } from "./refund-history.vue?vue&type=template&id=6fbfb1ee&"
import script from "./refund-history.vue?vue&type=script&lang=js&"
export * from "./refund-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports